/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'deleteCustomerDealerTankLimitsBySystemGameTypeId',
    message: messages.SUCCESS_DELETE_CUSTOMER_DEALER_TANK_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'DELETE',
    path: '/customer/:customerId/dealer-tank-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_DEALER_TANK_LIMIT,
    requestSchema: requestSchemas.customerDealerTankLimits.deleteCustomerDealerTankLimitsBySystemGameTypeId,
  },
  {
    action: 'getCustomerDealerTankLimitsBySystemGameTypeId',
    message: messages.SUCCESS_GET_CUSTOMER_DEALER_TANK_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'GET',
    path: '/customer/:customerId/dealer-tank-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_DEALER_TANK_LIMIT,
    requestSchema: requestSchemas.customerDealerTankLimits.getCustomerDealerTankLimitsBySystemGameTypeId,
    scopes: [
      scopes.CUSTOMER_DEALER_TANK_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID,
      scopes.CUSTOMER_DEALER_TANK_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID,
      scopes.DEFAULT,
    ],
  },
  {
    action: 'saveCustomerDealerTankLimitsBySystemGameTypeId',
    message: messages.SUCCESS_SAVE_CUSTOMER_DEALER_TANK_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'POST',
    path: '/customer/:customerId/dealer-tank-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.SAVE_CUSTOMER_DEALER_TANK_LIMIT,
    requestSchema: requestSchemas.customerDealerTankLimits.saveCustomerDealerTankLimitsBySystemGameTypeId,
  },
  {
    action: 'updateCustomerDealerTankLimitsBySystemGameTypeId',
    message: messages.SUCCESS_UPDATE_CUSTOMER_DEALER_TANK_LIMITS_BY_SYSTEM_GAME_TYPE_ID,
    method: 'PATCH',
    path: '/customer/:customerId/dealer-tank-limits/:systemGameTypeId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_DEALER_TANK_LIMIT,
    requestSchema: requestSchemas.customerDealerTankLimits.updateCustomerDealerTankLimitsBySystemGameTypeId,
  },
];
